import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Overline } from "../SectionHeading";
import { Seo, breadcrumbLd } from "../Seo";

// Shared shell for static content pages (policies, contact) — matches the
// storefront's existing header/hero/footer treatment. No redesign.
export const PageShell = ({ testId, overline, title, intro, path, children }) => (
  <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal" data-testid={testId}>
    <Seo
      title={title}
      description={intro}
      path={path}
      jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: title, path }])]}
    />
    <AnnouncementBar />
    <Header />
    <main>
      <section className="relative overflow-hidden border-b border-brand-sand bg-gradient-to-b from-brand-champagne/70 via-brand-cream to-brand-cream">
        <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
          <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-stone" data-testid="page-breadcrumb">
            <a href="/" className="transition-colors hover:text-brand-gold">Home</a>
            <span>/</span>
            <span className="text-brand-charcoal">{title}</span>
          </nav>
          {overline && <div className="mt-5"><Overline>{overline}</Overline></div>}
          <h1 className="mt-4 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-brand-charcoal sm:text-5xl" data-testid="page-title">
            {title}
          </h1>
          <div className="mt-6 h-px w-24 bg-gradient-to-r from-brand-gold to-transparent" aria-hidden="true" />
          {intro && (
            <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-brand-stone">
              {intro}
            </p>
          )}
        </div>
      </section>
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">{children}</div>
    </main>
    <Footer />
  </div>
);
